import { GuidedTourStep } from '../../../model/guided-tour-step';

export const myOrganizationSteps: GuidedTourStep[] = [
  {
    highlightTargetId: 'organizations-tile-content',
    clickTargetId: 'organizations',
    border: 15,
    description: {
      text: 'guidedTour.tours.guided-tour-oa-admin-area.section2.description.step1',
    },
    hideArrow: true,
  },
  {
    highlightTargetId: 'markant-body',
    shape: 'rectangle',
    ignoreHighlightClick: true,
    hideBackButton: true,
    nextOnOverlayClick: true,
  },
  {
    highlightTargetId: 'edit-organization-button',
    description: {
      text: 'guidedTour.tours.guided-tour-oa-admin-area.section2.description.step3',
    },
    nextOnOverlayClick: true,
    border: 20,
  },
  {
    highlightTargetId: 'toolbar-without-locations',
    description: {
      text: 'guidedTour.tours.guided-tour-oa-admin-area.section2.description.step4',
    },
    nextOnOverlayClick: true,
  },
  {
    highlightTargetId: 'locations-button',
    description: {
      text: 'guidedTour.tours.guided-tour-oa-admin-area.section2.description.step5',
    },
  },
  {
    highlightTargetId: 'markant-body',
    shape: 'rectangle',
    ignoreHighlightClick: true,
    hideBackButton: true,
    nextOnOverlayClick: true,
  },
  {
    highlightTargetId: 'locations-headline',
    description: {
      text: 'guidedTour.tours.guided-tour-oa-admin-area.section2.description.step7',
    },
    border: 10,
    nextOnOverlayClick: true,
  },
  {
    highlightTargetId: 'add-location-button',
    description: {
      text: 'guidedTour.tours.guided-tour-oa-admin-area.section2.description.step8',
    },
    nextOnOverlayClick: true,
  },
];
